import { plainToClass } from 'class-transformer';
import {
  API_CLIENT_FIND_ALL,
  API_CLIENT_FIND_ONE,
  API_CLIENT_CREATE,
  API_CLIENT_DELETE,
  API_CLIENT_UPDATE,
  API_CLIENT_EXPORT
} from '../api.routes';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { ClientDto } from '../dto';
import qs from 'qs';

export class ClientApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ClientDto>> {
    return this.httpClient
      .get(API_CLIENT_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ClientDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ClientDto> {
    return this.httpClient
      .get(API_CLIENT_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ClientDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ClientDto> {
    return this.httpClient.post(API_CLIENT_CREATE, data).then(({ data }) => {
      return plainToClass(ClientDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ClientDto> {
    return this.httpClient.put(API_CLIENT_UPDATE, data).then(({ data }) => {
      return plainToClass(ClientDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid, data): Promise<void> {
    return this.httpClient.delete(API_CLIENT_DELETE, {
      pathParams: { uuid },
      data
    });
  }

  /**
   * Export
   * @param data
   */
  public export(params): void {
    window.open(
      `${String(
        process.env.REACT_APP_API_URL
      ).trim()}/client/export${qs.stringify(params, {
        addQueryPrefix: true
      })}`
    );
  }
}
